var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 19,
    y: 32,
    fill: "#6c19ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 4,
    x: 12,
    y: 38,
    fill: "#6c19ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 23,
    x: 5,
    y: 7,
    fill: "#3dd9eb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 5,
    x: 5,
    y: 30,
    fill: "#6c19ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 3,
    x: 19,
    y: 32,
    fill: "#2100c4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 3,
    x: 12,
    y: 16,
    fill: "#6c19ff",
    transform: "rotate(-45.001 15.5 17.5)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 13.996,
    y: 16.829,
    fill: "#6c19ff",
    transform: "rotate(-45.001 15.497 20.33)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.998,
    height: 3,
    x: 12.586,
    y: 17.415,
    fill: "#2100c4",
    transform: "rotate(-45.001 14.085 18.916)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 7,
    x: 30.997,
    y: 14,
    fill: "#6c19ff",
    transform: "rotate(-45.001 32.498 17.5)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 3,
    x: 28.999,
    y: 18.829,
    fill: "#6c19ff",
    transform: "rotate(-45.001 32.5 20.33)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2.998,
    x: 32.411,
    y: 17.416,
    fill: "#2100c4",
    transform: "rotate(-45.001 33.912 18.916)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6c19ff",
    points: "24.233,10 20.71,28 23.767,28 27.29,10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontend);
export default __webpack_public_path__ + "static/media/frontend.2236143665fca571ad94b6f9c94a030d.svg";
export { ForwardRef as ReactComponent };